// ----------------------------------------------------------------------

export default function Drawer(theme) {
  return {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          // Apply max-width constraint for ultrawide screens
          // This constrains drawers to 1500px max on xl+ screens
          // Percentage widths (like 66%, 78%) will still work but be capped at 1500px
          [theme.breakpoints.up('xl')]: {
            maxWidth: '1500px',
          },
        },
      },
    },
  };
}

